// =============================================================
// 🤖 AutoResolutionRateChart.jsx — Taxa de Resolução Automática
// =============================================================

import React from "react";

export default function AutoResolutionRateChart({ rate }) {
  const value = Math.round((rate ?? 0) * 100);

  return (
    <div className="ia-chart-wrapper ia-chart-auto-resolution">
      <div className="ia-auto-resolution-circle">
        <div className="ia-auto-resolution-value">{value}%</div>
        <div className="ia-auto-resolution-label">Resolvido só pela IA</div>
      </div>

      <p className="ia-chart-desc">
        Percentual de sessões finalizadas sem intervenção humana.  
        Um ótimo indicador da eficiência da IA do Amor.
      </p>
    </div>
  );
}
